export const createScript = (url) => {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.setAttribute('src', url);
    script.setAttribute('type', 'text/javascript');
    document.body.appendChild(script);
    script.onload = (res) => {
      resolve(res);
    };
    script.onerror = (error) => {
      reject(error);
    };
  });
};

export const createCss = (url) => {
  return new Promise((resolve, reject) => {
    let link = document.createElement('link');
    link.setAttribute('href', url);
    link.setAttribute('type', 'text/css');
    link.setAttribute('rel', 'stylesheet');
    document.body.appendChild(link);
    link.onload = (res) => {
      resolve(res);
    };
    link.onerror = (error) => {
      reject(error);
    };
  });
};



// WEBPACK FOOTER //
// ./src/utils/staticAssets.js